import { isNxtHorizon, isNxtHorizonHD, isSMAscenderFlush, isSolarMount } from "__common/constants/products";
import { state } from "__common/store";
import { RoofType } from "../utils/projectConfigEnums";
import s5Attachmentpreference from "./s5AttachmentpreferenceField";
import { smTileReplacementsOrSolarhooks } from "./smTileReplacementsOrSolarhooks";

export const apiField = 'attachment_type';

export enum AttachmentType {
  UNIRAC_FLASHLOC_RM = 1,
  U_ANCHOR_U2400 = 2,
  CUSTOM = 3,
  OMG = 21,
  PM_9000S = 19,
  PM_ADJUST = 20,
  MINI_1SS = 16,
  STAND_2SS = 17,
  WIDE_2SS = 18,
  SOLARHOOK_FLAT_TILE = 12,
  SOLARHOOK_9_IN_BASE = 13,
  SOLARHOOK_7_IN_BASE = 14,
  SOLARHOOK_UNIVERSAL =  15,
  L_FOOT_ONLY = 21,
  FLASHKIT_PRO = 22,
  FLASHLOC_COMP_KIT = 23,
  FLASHLOC_DUO = 24,
  STRONGHOLD_ATT_KIT_COMP = 27,
  STRONGHOLD_ATT_COMP_NS = 28,
  FLASHKIT_PRO_SB = 29,
  STRONGHOLD_ATT_BUTYL = 30,
  FLASHKIT = 31,
  SFM_BUTYL_DTD = 32,
  SM_BUTYL_DTD = 33,
  PERFORMANCE_HOOK = 34,
  BUTYL = 35,
  NXT_S5_PROTEA_BRACKET_ASSEMBLY = 36,
}

export const IFI_ATTACHMENT_TYPE = [
  {
    value: AttachmentType.UNIRAC_FLASHLOC_RM,
    name: 'UNIRAC FLASHLOC RM',
  },
  {
    value: AttachmentType.U_ANCHOR_U2400,
    name: 'U-ANCHOR',
  },
  {
    value: AttachmentType.CUSTOM,
    name: 'CUSTOM',
  },
];

const RM10_ATTACHMENT_TYPE = [...IFI_ATTACHMENT_TYPE];
RM10_ATTACHMENT_TYPE.splice(2, 0, {
  value: AttachmentType.OMG,
  name: "OMG",
});

export const SM_FLUSH_ATT = [
  {
    value: AttachmentType.L_FOOT_ONLY,
    name: 'L Foot',
  },
  {
    value: AttachmentType.FLASHKIT_PRO,
    name: 'FLASHKIT PRO',
  },
  {
    value: AttachmentType.FLASHLOC_COMP_KIT,
    name: 'FLASHLOC COMP',
  },
  {
    value: AttachmentType.FLASHLOC_DUO,
    name: 'FLASHLOC DUO',
  },
  {
    value: AttachmentType.FLASHKIT_PRO_SB,
    name: 'FLASHKIT PRO SB',
  },
  {
    value: AttachmentType.SM_BUTYL_DTD,
    name: 'SM BUTYL',
  },
];

export const R_PANEL_ROOF_ATT = [
  {
    value: AttachmentType.PM_ADJUST,
    name: 'PM ADJUST SLOTTED',
  },
  {
    value: AttachmentType.PM_9000S,
    name: 'PM-9000S',
  },
];

export const NXT_R_PANEL_ROOF_ATT = [
  {
    value: AttachmentType.NXT_S5_PROTEA_BRACKET_ASSEMBLY,
    name: 'NXT S-5! Protea Bracket Assembly',
  },
  ...R_PANEL_ROOF_ATT,
];

export const NXT_ONLY_ATT = [
  {
    value: AttachmentType.STRONGHOLD_ATT_KIT_COMP,
    name: 'STRONGHOLD ATTACHMENT',
  },
  {
    value: AttachmentType.STRONGHOLD_ATT_BUTYL,
    name: 'STRONGHOLD ATT W/BUTYL',
  },
];

export const SFM_INFINITY_ATTACHMENT_TYPES = [
  {
    value: AttachmentType.FLASHKIT,
    name: 'FLASHKIT',
  },
  {
    value: AttachmentType.SFM_BUTYL_DTD,
    name: 'SFM Butyl',
  },
];

interface AttachmentTypeOption {
  value: AttachmentType;
  name: string;
}

const makeConfig = (data: AttachmentTypeOption[]) => ({
  label: 'attachmentType',
  type: 'Select',
  apiField,
  missing: undefined,
  data,
  id: 'attachmentType',
  labelClassName: 'label-height-16',
}
);

const config = makeConfig(IFI_ATTACHMENT_TYPE);

export const rm10AttachmentType = makeConfig(RM10_ATTACHMENT_TYPE);
export const sfmInfinityAttachmentType = makeConfig(SFM_INFINITY_ATTACHMENT_TYPES);

const keyToRemove = 'value';
const valueToRemove = AttachmentType.U_ANCHOR_U2400;
const flashlocRmValueRemove = AttachmentType.UNIRAC_FLASHLOC_RM;
export const attachmentTypesWithoutUanchor = makeConfig(removeUanchorFromList(IFI_ATTACHMENT_TYPE, keyToRemove, valueToRemove));
export const rm10AttachmentTypeWithoutUanchor = makeConfig(removeUanchorFromList(RM10_ATTACHMENT_TYPE, keyToRemove, valueToRemove));
export const attachmentTypeWithoutFlachlocrm = makeConfig(removeUanchorFromList(IFI_ATTACHMENT_TYPE, keyToRemove, flashlocRmValueRemove));
export const rm10AttachmentTypeWithoutFlachlocrm = makeConfig(removeUanchorFromList(RM10_ATTACHMENT_TYPE, keyToRemove, flashlocRmValueRemove));

export const smAndNxtAttachmentTypes = (roof_type, productTd) => {
  const {projectConfiguration: {railsProductId}} = state();
  return {
    type: 'Select',
    label: 'attachmentType',
    apiField,
    missing : undefined,
    data: isNxtHorizon(productTd)? nhAttachmentData(roof_type, railsProductId) : smAttachmentData(roof_type),
  };
};

const smAttachmentData = (roofType) => {
  const { projectConfiguration: { railsProductId } } = state();

  if(isSMAscenderFlush(railsProductId) && roofType == RoofType.SHINGLE) {
    return [
      {
        value: AttachmentType.L_FOOT_ONLY,
        name: 'L Foot',
      },
      {
        value: AttachmentType.FLASHKIT_PRO,
        name: 'Flashkit Pro',
      },
      {
        value: AttachmentType.FLASHKIT_PRO_SB,
        name: 'Flashkit Pro SB',
      },
    ];
  }

  switch (roofType) {
    case  RoofType.R_PANEL:
      return R_PANEL_ROOF_ATT;
    case RoofType.OTHERS:
      return getCorrectAttachmentsData(
        SM_FLUSH_ATT,
        [3,4,5],
      ); 
    default:
      return SM_FLUSH_ATT;
  }
};

export const getCorrectAttachmentsData = (arr: AttachmentTypeOption[], indexes: number[]) => {
  return arr.filter((a,i)=> !indexes.includes(i));
};


const nhAttachmentData = (roofType, railsProductId) => {  
  switch (roofType) {
    case  RoofType.R_PANEL:
      return NXT_R_PANEL_ROOF_ATT;
    default:
      return NXT_ONLY_ATT.concat(getCorrectAttachmentsData(
        SM_FLUSH_ATT,
        [2, 5],
      ));
  }
};

export function removeUanchorFromList(dataList, key, value) {
  return dataList.filter(item => item[key] !== value);
}

// Lite-only: returns the attachment field config that drives Lite's BOM
// right-panel dropdown for the project's (product, roof) combo. Mirrors
// the inline spread pattern in NxtHorizonConfig.ts:249-265 and
// SmConfig.ts:264-278 — kept here (rather than a v3/ folder) so the
// imports of s5Attachmentpreference / smTileReplacementsOrSolarhooks
// stay co-located with the legacy primitives they wrap. Legacy callers
// don't use this; the `Lite` prefix is the marker.
//   - STANDING_SEAM → s5Attachmentpreference (writes s5_or_sci)
//   - TILE          → smTileReplacementsOrSolarhooks (writes tile_replacement_or_solarhooks)
//   - default       → smAndNxtAttachmentTypes (writes attachment_type)
export const getLiteNxtSmAttachmentField = (productId: number, roofType: number, railsProductId?: number) => {
  if (roofType === RoofType.STANDING_SEAM) return s5Attachmentpreference;
  if (roofType === RoofType.TILE) return smTileReplacementsOrSolarhooks(productId, railsProductId);
  return smAndNxtAttachmentTypes(roofType, productId);
};

// Lite-only: returns the FULL set of attachment_type options available to
// an NXT/SM product, grouped by roof type so the Lite BOM dropdown can show
// every option in a single select (with <optgroup>s) regardless of which
// roof type the project was created with. All options write to the
// `attachment_type` apiField. Roof-specific preference fields (s5_or_sci,
// tile_replacement_or_solarhooks) are intentionally not surfaced here —
// Lite treats the picked attachment_type as the source of truth.
export const getLiteAllAttachmentTypesGrouped = (productId: number, roofType?: number, railsProductId?: number) => {
  const groups: Array<{ label: string; data: Array<{ value: AttachmentType | string; name: string }> }> = [];
  const isNxt = isNxtHorizon(productId);
  const isSm = isSolarMount(productId);
  if (!isNxt && !isSm) return null;

  if (isSm && isSMAscenderFlush(railsProductId) && roofType === RoofType.SHINGLE) {
    return {
      type: 'Select',
      label: 'attachmentType',
      apiField,
      missing: undefined,
      data: smAttachmentData(RoofType.SHINGLE),
    };
  }

  // Shingle / Composition / Others — base flush kit list. NXT adds its
  // STRONGHOLD attachments on top.
  const shingleBase = getCorrectAttachmentsData(SM_FLUSH_ATT, isNxt ? [2, 5] : []);
  const shingleData = isNxt ? NXT_ONLY_ATT.concat(shingleBase) : SM_FLUSH_ATT;
  groups.push({ label: 'Shingle / Composition', data: shingleData });

  // R-Panel
  groups.push({ label: 'R-Panel', data: NXT_R_PANEL_ROOF_ATT });

  // Standing Seam (S-5!)
  // groups.push({
  //   label: 'Standing Seam (S-5!)',
  //   data: [
  //     { value: 'standing_seam_s5', name: 'Standing seam(S-5!)' }
  //   ]
  // });

  // Standing Seam (SCI attachments — the attachment_type-valued half of the
  // standing-seam picker; S-5! preference cascade is roof-specific and not
  // a flat attachment_type list).
  groups.push({ label: 'Standing Seam (SCI)', data: smSciOptions });

  // Tile (Solarhooks)
  groups.push({ label: 'Tile (Solarhooks)', data: solarhookOptions });

  // Tile Replacement has no group label, just a single attachment option.
  groups.push({ label: '', data: [{ value: 'tile_replacement', name: 'Tile Replacement' }] });

  return {
    type: 'Select',
    label: 'attachmentType',
    apiField,
    missing: undefined,
    groups,
  };
};

// Inlined here to avoid a circular import on smStandardSeamMetalAttachment /
// smSolarhooksAttachments (those modules also export `apiField`).
const smSciOptions: AttachmentTypeOption[] = [
  { value: AttachmentType.MINI_1SS, name: 'Mini 1ss' },
  { value: AttachmentType.STAND_2SS, name: 'Stand 2ss' },
  { value: AttachmentType.WIDE_2SS, name: 'Wide 2ss' },
];
const solarhookOptions: AttachmentTypeOption[] = [
  { value: AttachmentType.SOLARHOOK_FLAT_TILE, name: 'AT1-Flat Tile' },
  { value: AttachmentType.SOLARHOOK_9_IN_BASE, name: 'CT2-Spanish 9" Base' },
  { value: AttachmentType.SOLARHOOK_7_IN_BASE, name: 'CT1-Spanish 7" Base' },
  { value: AttachmentType.SOLARHOOK_UNIVERSAL, name: 'CT5-Universal' },
  { value: AttachmentType.PERFORMANCE_HOOK, name: 'Performance Hook' },
];

export const adjustibleTiltAttachmentTypes = () => {
  return {
    type: 'Select',
    label: 'attachmentType',
    apiField,
    missing : undefined,
    data: adjustibleTiltAttachmentData(),
  };
};

const adjustibleTiltAttachmentData = () => {
  return [
      {
        value: AttachmentType.BUTYL,
        name: 'Butyl',
      },
      {
        value: AttachmentType.L_FOOT_ONLY,
        name: 'L Foot',
      },
    ];
};

export default config;
